import axios from 'axios';

const pendingRequests = new Map();
const generateRequestKey = (config) => [config.method, config.url, JSON.stringify(config.params), JSON.stringify(config.data)].join('&');

export const addPendingRequest = (config) => {
  const requestKey = generateRequestKey(config);
  config.cancelToken = config.cancelToken
      || new axios.CancelToken((cancel) => {
        if (!pendingRequests.has(requestKey)) {
          pendingRequests.set(requestKey, cancel);
        }
      });
};

export const removePendingRequest = (config) => {
  const requestKey = generateRequestKey(config);
  if (pendingRequests.has(requestKey)) {
    const cancel = pendingRequests.get(requestKey);
    cancel('取消重复请求');
    pendingRequests.delete(requestKey);
  }
};
